import deepMerge from 'deepmerge';
import { widgetSettings as defaultWidgetSettings, metricWidgetSettings as defaultMetricWidgetSettings, choroplethWidgetSettings as defaultChoroplethWidgetSettings, bubbleWidgetSettings as defaultBubbleWidgetSettings, } from '@keen.io/widgets';
export var extendWidgetSettings = function (customSettings, widgetType) {
    if (customSettings === void 0) { customSettings = {}; }
    switch (widgetType) {
        case 'choropleth':
            return deepMerge(defaultChoroplethWidgetSettings, customSettings);
        case 'metric':
            return deepMerge(defaultMetricWidgetSettings, customSettings);
        case 'bubble':
            return deepMerge(defaultBubbleWidgetSettings, customSettings);
        default:
            return deepMerge(defaultWidgetSettings, customSettings);
    }
};
